import { Card, CloseBtn, FormUi, SaveBtn } from "../../ui";
import { Col, Form, Row, Space, Tooltip } from "antd";
import { InventarioInicialForm } from "./InventarioInicialForm";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  DateFormats,
  EstadoInventarioInicial,
} from "../../../types/typesConstants";
import {
  inventarioInicialStartAdd,
  inventarioInicialStartUpdate,
} from "../../../actions";
const initialValues = (data = {}) => ({
  id: data?.id || null,
  periodo: data?.periodo || null,
  almacen: data?.almacen || null,
  estado: data?.estado || EstadoInventarioInicial.BORRADOR,
  tipomovimiento: data?.tipomovimiento || null,
  detallesinventarioinicial: data?.detallesinventarioinicial || [],
});
export const InventarioInicialScreen = ({ handleCloseForm }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeInventarioInicial } = useSelector((state) => state.inventario);
  const { activeEmpleado } = useSelector((state) => state.auth);
  const handleSubmit = (values) => {
    values = {
      ...values,
      empresa: activeEmpleado?.empresa?.id,
      detallesinventarioinicial: values?.detallesinventarioinicial?.map(
        (row) => ({
          id: row?.id || 0,
          item: row?.item,
          stockminimo: row?.stockminimo,
          unidadmedida: row?.unidadmedida,
          costo: row?.costo,
          moneda: row?.moneda,
          cantidad: row?.cantidad,
          detalleslotesinventarioinicial:
            row?.detalleslotesinventarioinicial?.map((x) => ({
              ...x,
              fecha_fabricacion: dayjs(x?.fecha_fabricacion).format(
                DateFormats.backend
              ),
              fecha_vencimiento: dayjs(x?.fecha_vencimiento).format(
                DateFormats.backend
              ),
            })),
          detallesseriesinventarioinicial:
            row?.detallesseriesinventarioinicial?.map((x) => ({
              ...x,
              fecha_fabricacion: dayjs(x.fecha_fabricacion).format(
                DateFormats.backend
              ),
            })),
        })
      ),
    };
    if (activeInventarioInicial) dispatch(inventarioInicialStartUpdate(values));
    else dispatch(inventarioInicialStartAdd(values));
    handleCloseForm();
  };
  return (
    <Form.Provider
      onFormFinish={(name, { values, forms }) => {
        const { FormInventarioInicial } = forms;
        let detallesinventarioinicial =
          FormInventarioInicial.getFieldValue("detallesinventarioinicial") ||
          [];
        if (name === "FormItemsDetalle") {
          const nuevosItems = values?.items?.filter(
            (obj1) =>
              !detallesinventarioinicial.some((obj2) => obj2.id === obj1.id)
          );
          detallesinventarioinicial = [
            ...nuevosItems,
            ...detallesinventarioinicial,
          ];
          form.setFieldValue(
            "detallesinventarioinicial",
            detallesinventarioinicial
          );
        }
        if (name === "FormDetalleSerieLote") {
          const series = values?.series;
          const lotes = values?.lotes?.filter((e) => e.cantidad !== null);
          detallesinventarioinicial = detallesinventarioinicial.map((item) =>
            item.id === values?.item
              ? {
                  ...item,
                  detallesseriesinventarioinicial: series,
                  detalleslotesinventarioinicial: lotes,
                }
              : item
          );
          form.setFieldValue(
            "detallesinventarioinicial",
            detallesinventarioinicial
          );
        }
      }}
    >
      <FormUi
        name="FormInventarioInicial"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues(activeInventarioInicial)}
        handleSubmit={handleSubmit}
      >
        <Card
          title={
            <Row>
              <Col sm={24} md={12}>
                Inventario inicial
                {activeInventarioInicial ? (
                  <small> Editar</small>
                ) : (
                  <small> Registrar</small>
                )}
              </Col>
            </Row>
          }
          size="small"
          extra={
            <Space className="site-button-ghost-wrapper" wrap>
              <Tooltip title="Salir">
                <CloseBtn onClick={handleCloseForm} />
              </Tooltip>
              <Tooltip title="Guardar">
                <SaveBtn htmlType="submit" />
              </Tooltip>
            </Space>
          }
        >
          <InventarioInicialForm />
        </Card>
      </FormUi>
    </Form.Provider>
  );
};
